'use client'

import React from 'react'
import {ThemeProvider} from 'styled-components'

import theme from '@/src/config/theme'
import {GlobalStyles} from '@/src/shared/assets/styles/global'

export function Theme({children}: React.PropsWithChildren) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {children}
    </ThemeProvider>
  )
}
